import { BLOG_I18N } from "./blogTranslations";
import { CITY_GUIDES_I18N } from "./cityGuides";

// Merge city-guide translations into the blog i18n map.
for (const lang of Object.keys(CITY_GUIDES_I18N)) {
  BLOG_I18N[lang] = { ...(BLOG_I18N[lang] || {}), ...CITY_GUIDES_I18N[lang] };
}

// Return a blog post with its title/excerpt/tag/body localized for `lang`.
export function locPost(post, lang) {
  if (!post) return post;
  const o = lang && lang !== "de" && BLOG_I18N[lang] && BLOG_I18N[lang][post.slug];
  return o ? { ...post, ...o } : post;
}
